import { useNavigate } from 'react-router-dom';
import useUserService from './useUserService';
import useService from '../../injector/hooks/useService';
import { LocalStorageService } from '../../core/services/local-storage.service';

import { SETUP_PERSONA_REQUIRED } from '../constants/auth';

export function useUserPersonaGuard() {
  const navigate = useNavigate();
  const { user } = useUserService();
  const localStorageService = useService(LocalStorageService);

  const executeUserPersonaGuard = () => {
    let canActivate = true;

    const forceUserPersona = localStorageService.get(SETUP_PERSONA_REQUIRED);

    if (user.role) {
      localStorageService.remove(SETUP_PERSONA_REQUIRED);
    } else if (forceUserPersona) {
      canActivate = false;
      navigate('/setup-persona');
    }

    return canActivate;
  };

  return {
    executeUserPersonaGuard
  };
}
